import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import {HERO_APPLICATION_PREFIX, HERO_APPLICATIONS} from "lib-hero";

import {IStringAnyMap,BooxEnvironmentService, BooxSessionService} from "lib-boox";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {NgClass, NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {MenuApplicationPipe} from "../../pipe/menu-application.pipe";
import {ProfileComponent} from "../profile/profile.component";
import {NotificationComponent} from "../notification/notification.component";

@Component({
  selector: 'host-menu',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    NgClass,
    NgForOf,
    MenuApplicationPipe,
    NgIf,
    NgOptimizedImage,
    ProfileComponent,
    NotificationComponent
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  // collapse
  private _collapse : boolean = false;
  @Input('collapse') public set collapse(value : boolean) {
    this._collapse = value;
    this.collapseChange.emit(this._collapse);
  }
  public get collapse() : boolean {
    return this._collapse;
  }

  @Output('collapseChange') public collapseChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  // admin
  private _admin : boolean = false;
  @Input('admin') public set admin(value : boolean) {
    this._admin = value;
    this.adminChange.emit(this._admin);
  }
  get admin() : boolean {
    return this._admin;
  }
  @Output('adminChange') public adminChange: EventEmitter<boolean> = new EventEmitter<boolean>();


  private _disableLogout : boolean = false;
  public get disableLogout() : boolean {
    return this._disableLogout;
  }

  private _disableRenew : boolean = false;
  public get disableRenew() : boolean {
    return this._disableRenew;
  }

  private _expireSoon : boolean = false;
  public get expireSoon() : boolean {
    return this._expireSoon;
  }

  private _sessionCountdown : number = 0;
  public get sessionCountdown() : number {
    return this._sessionCountdown;
  }


  constructor(
    @Inject(HERO_APPLICATIONS) public applications: IStringAnyMap[],
    @Inject(HERO_APPLICATION_PREFIX) public applicationPrefix: string,
    private sessionServ: BooxSessionService,
    private envServ : BooxEnvironmentService
  ){

    this.sessionServ.sessionExpiredSoon$.subscribe((expiredSoon: boolean) => {
      this._expireSoon = expiredSoon;
    });
    // this.sessionServ.sessionValidUntil$.subscribe((validUntil: number) => {
    //   this._sessionCountdown = validUntil;
    // });

    this.envServ.load().subscribe((env) => {
      console.log(env.apps.map((app:IStringAnyMap) => app['path']));
    });
  }

  ngAfterViewInit(): void {

  }

  /**
   * toggle menu collapse
   */
  public toggleCollapse(){
    this.collapse = !this.collapse;
  }

  /**
   * toggle admin
   */
  public toggleAdmin(){
    this.admin = !this.admin;
  }


  logout(){
    this._disableLogout = true;
    this.sessionServ.signOut().subscribe({
      error: () => {
        this._disableLogout = false;
      },
      complete: () => {
        this._disableLogout = false;
      }
    });
  }

  renew(){
    this._disableRenew = true;
    this.sessionServ.renew().subscribe({
      error: () => {
        this._disableRenew = false;
      },
      complete: () => {
        this._disableRenew = false;
      }
    });
  }
}
